!function() {
  class e extends HTMLElement {
    constructor() {
      super(), this.perPage = 5, this.currentReviewPage = 0, this.sortBy = "date", this.sortDirection = "desc", 
      this.sortingConfig = {
        elastic_search_score: {
          sort_by: "_score",
          ascending: !1
        },
        badge: {
          sort_by: "reviewer_type",
          ascending: !1
        },
        score: {
          sort_by: "score",
          ascending: !1
        },
        low_score: {
          sort_by: "score",
          ascending: !0
        },
        date: {
          sort_by: "date",
          ascending: !1
        },
        votes: {
          sort_by: "votes_up",
          ascending: !1
        },
        low_votes: {
          sort_by: "votes_down",
          ascending: !1
        },
        images: {
          sort_by: "image_count",
          ascending: !1
        },
        grouping: {
          sort_by: "grouping_originated",
          ascending: !0
        }
      }, this.appkey = this.dataset.appkey, this.options = {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      };
    }
    connectedCallback() {
      this.appkey ? (this.init(), this.addEventListener("click", this.onClickHandler.bind(this)), 
      this.addEventListener("change", this.onChangeHandler.bind(this))) : this.hide();
    }
    show() {
      this.closest(".max-h-0")?.classList.remove("max-h-0", "overflow-hidden");
    }
    hide() {
      const e = this.closest(".shopify-section");
      e && e.parentNode.removeChild(e);
    }
    loadStart(e) {
      e?.classList.add("opacity-50", "cursor-wait", "pointer-events-none");
    }
    loadEnd(e) {
      e?.classList.remove("opacity-50", "cursor-wait", "pointer-events-none");
    }
    onChangeHandler(e) {
      e.target?.hasAttribute("data-sort") && (e.preventDefault(), this.sortBy = e.target.value, 
      this.sortDirection = e.target.selectedOptions[0]?.dataset.direction || "desc", this.getReviews());
    }
    onClickHandler(e) {
      e.target.hasAttribute("data-reviews-loader") && (e.preventDefault(), this.getReviews(this.currentReviewPage + 1));
    }
    updateCounts(e) {
      this.total = e.pagination?.total || e.bottomline?.total_review || "", this.pages = Math.ceil(this.total / this.perPage);
    }
    renderSection(e) {
      this.updateCounts(e), this.querySelector("[data-rating]").textContent = e.bottomline?.average_score ? e.bottomline?.average_score?.toFixed(1) : "", 
      this.querySelector("[data-total-review]").textContent = this.total;
    }
    renderReviews(e) {
      this.updateCounts(e);
      const t = this.querySelector("template[data-template-review]"), s = (this.querySelector("template[data-template-review-detail]"), 
      this.querySelector("[data-reviews]"));
      this.currentReviewPage || this.renderSection(e), this.currentReviewPage = e.pagination.page, 
      1 == this.currentReviewPage && (s.innerHTML = ""), 0 !== e.reviews.length && (e.reviews.forEach((e => {
        const i = t.content.cloneNode(!0), r = new Date(e.created_at), a = new Intl.DateTimeFormat("en-GB", {
          year: "2-digit",
          month: "2-digit",
          day: "2-digit"
        }).format(r);
        i.children[0].style.setProperty("--score", e.score), i.querySelector("[data-title]").innerHTML = e.title, 
        i.querySelector("[data-content]").innerHTML = e.content, i.querySelector("[data-display-name]").innerHTML = e.user.display_name, 
        i.querySelector("[data-date]").innerHTML = a, e.verified_buyer || i.querySelector("[data-verified]").classList.remove("hidden"), 
        s.appendChild(i);
      })), this.currentReviewPage >= this.pages ? this.querySelector("[data-reviews-loader]").classList.add("hidden") : this.querySelector("[data-reviews-loader]").classList.remove("hidden"), 
      this.querySelectorAll("[data-topic]").forEach((e => e.ariaCurrent = this.topics.includes(e.textContent.trim()))), 
      this.show());
    }
    async getFilteredReviews(e = 1) {
      let t = new URL(`https://api-cdn.yotpo.com/v1/reviews/${this.appkey}/filter.json`);
      t.searchParams.set("per_page", this.perPage), t.searchParams.set("page", e);
      let s = {
        domain_key: parseInt(this.product.id),
        sortings: [ this.sortingConfig[this.sortBy] ],
        sort: this.sortBy,
        ascending: !1,
        pictured: !0
      };
      fetch(t, {
        ...this.options,
        method: "POST",
        body: JSON.stringify(s)
      }).then((e => e.json())).then((e => this.renderReviews(e.response))).catch((e => console.error("error:" + e)));
    }
    async getReviews(e = 1) {
      let t = new URL(`https://api-cdn.yotpo.com/v1/widget/${this.appkey}/products/${this.dataset.productId}/reviews.json`);
      t.searchParams.set("per_page", this.perPage), t.searchParams.set("page", e), t.searchParams.set("sort", this.sortBy), 
      t.searchParams.set("direction", this.sortDirection || "desc"), fetch(t, this.options).then((e => e.json())).then((e => this.renderReviews(e.response))).catch((e => console.error("error:" + e)));
    }
    init() {
      this.product = JSON.parse(this.querySelector('[type="application/json"]').textContent), 
      this.getReviews();
    }
  }
  customElements.get("product-reviews") || customElements.define("product-reviews", e);
}();